import React from 'react';
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

interface FetchClosedNotificationsConnectorFirestoreDbProps {
  children: (props: {
    loading: boolean;
    closedNotifications: number[];
    getClosedNotificationsValues: () => Promise<void>;
  }) => React.ReactElement;
  getClosedNotifications: (collectionName: string, userId: number) => Promise<number[]>;
  userId: number;
  collectionName: string;
}

const FetchClosedNotificationsConnectorFirestoreDb: React.FC<
  FetchClosedNotificationsConnectorFirestoreDbProps
> = ({ children, getClosedNotifications, userId, collectionName }) => {
  const [loading, setLoading] = useState(true);
  const [closedNotifications, setClosedNotifications] = useState<number[]>([]);

  const getClosedNotificationsValues = async () => {
    try {
      const closedNotificationsResponseData = await getClosedNotifications(collectionName, userId);
      setClosedNotifications(closedNotificationsResponseData);
    } catch (err) {
      console.error('Failed to fetch config values:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getClosedNotificationsValues();
  }, [getClosedNotifications]);

  return children({ loading, closedNotifications, getClosedNotificationsValues });
};

export default FetchClosedNotificationsConnectorFirestoreDb;
